import { Point } from 'pixi.js';
import { KeyboardInput } from './../utils/KeyboardInput';
import { ScreenGame } from './../screens/ScreenGame';
import { Player } from './../common/Player';

export class Controller {
    constructor(game) {
        this.keyboardInput = new KeyboardInput(ScreenGame.action);
        this.tilemap = game.tilemap;
        this.player = game.player;
        this.missionRunner = game.missionRunner;

        this.stickyActions = new Map();
        this.stickyActionsData = new Map();
        this.keyChange = false;

        this.bindInput(this.keyboardInput, ScreenGame.action);
    }

    bindInput(controller, actions) {
        this.controller = controller;
        this.controller.on(actions.moveUp, (data) => this.updateActionState(Player.direction.up, data), this);
        this.controller.on(actions.moveDown, (data) => this.updateActionState(Player.direction.down, data), this);
        this.controller.on(actions.moveLeft, (data) => this.updateActionState(Player.direction.left, data), this);
        this.controller.on(actions.moveRight, (data) => this.updateActionState(Player.direction.right, data), this);
        this.controller.on(actions.interact, (data) => this.onInteract(data), this);
    }

    updateActionState(action, data) {
        this.stickyActions.set(action, data.autoRepeat.repeat);
        this.stickyActionsData.set(action, data);
        this.keyChange = true;
    }

    onInteract(data) {
        if (data.isDown) return;

        let interactPos = new Point(this.player.tileX, this.player.tileY);
        this.missionRunner.onInteract({ interactPos: interactPos });
    }

    calculateMovement() {
        let targetPos = { x: 0, y: 0 };

        if (this.stickyActions.get(Player.direction.up)) targetPos.y -= 1;
        if (this.stickyActions.get(Player.direction.down)) targetPos.y += 1;
        if (this.stickyActions.get(Player.direction.left)) targetPos.x -= 1;
        if (this.stickyActions.get(Player.direction.right)) targetPos.x += 1;

        return targetPos;
    }

    update(dt) {
        this.keyboardInput.update(dt);
        
        this.player.update(dt);

        if (this.keyChange) {
            this.moveDelta = this.calculateMovement();
            this.player.updateMovement(this.moveDelta);
            this.keyChange = false;
        } else {
            this.player.tryAutoMove();
        }
    }
}
